export const columns = [
    {
      name: 'Title',
      selector: 'Title',
      //sortable: true,
      center: true,
      compact: true,
      width: '40%',
      wrap: true,
      sortable: true,
    },

    {
      name: 'Issue',
      selector: 'Issue #',
      center: true,
      compact: true,
      width: '10%',
      wrap: true,
    },
    
    {
      name: 'Condition',
      selector: 'Condition',
      center: true,
      compact: true,
      width: '20%',
      wrap: true,


    },

    {
      name: 'Notes',
      selector: 'Website Notes',
      center: true,
      compact: true,
      width: '30%',
      wrap: true,

    }
  ];